module.exports = __webpack_public_path__ + "static/media/ehtesham-avatar.acbf97e1.jpg";